import React, {useState, useEffect} from "react";
import { withRouter } from "react-router-dom";
import notify from "../../components/notifier";
import userService from "../../services/user"
import { Button, Container, Row, Col} from "reactstrap";
import OwlCarousel from 'react-owl-carousel';
import MEDIA_URL from "../../contants";
const VirtualGames = (props) => {

  const [games, setGames] = useState([]);
  const [Carousal, setCarousal] = useState(false);
  
  const showEvolution = (data) => {
    // console.log('balicwwod caniod', data)
    //get user login or not if not login then user can not open casino
    const getPlayerInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    // console.log("please login", data);

    if (getPlayerInfo === null || getPlayerInfo.user.PortalName !== 'SportsX9') {
      notify("First login then open Casino", "error", "top-right");
      return;
    }
    if (data === 'Virtual-Cricket-In-Play') {
      const url = window.location.origin + '/virtual-sports/BR/vci';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual-Football-World-Cup') {
      const url = window.location.origin + '/virtual-sports/BR/vfwc';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual-Tennis-In-Play') {
      const url = window.location.origin + '/virtual-sports/BR/vti';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual-Horses') {
      const url = window.location.origin + '/virtual-sports/BR/vhk';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'dogs') {
      const url = window.location.origin + '/virtual-sports/BR/vdk';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual-Baseball-In-Play') {
      const url = window.location.origin + '/virtual-sports/BR/vbi';
      window.open(
        url,
        "_self"
      );  
      return;
    } else if (data === 'Virtual-Basketball-League') {
      const url = window.location.origin + '/virtual-sports/BR/vbl';
      window.open(
        url,
        "_self"
      );  
      return;
    }

  };

  useEffect( () => {
    const casinoArray = [
      {
        title: "Virtual-Cricket-In-Play",
        img: "Virtual-Cricket-In-Play.webp",
        type: "Virtual-Cricket-In-Play"
      },
      {
        title: "Virtual-Football-World-Cup",
        img: "Virtual-Football-World-Cup.webp",
        type: "Virtual-Football-World-Cup"
      },
      {
        title: "Virtual-Tennis-In-Play",
        img: "Virtual-Tennis-In-Play.webp",
        type: "Virtual-Tennis-In-Play"
      },
      {
        title: "Virtual-Horses",
        img: "Virtual-Horses.webp",
        type: "Virtual-Horses"
      },
      {
        title: "dogs",
        img: "dogs.webp",
        type: "dogs"
      },
      {
        title: "Virtual-Baseball-In-Play",
        img: "Virtual-Baseball-In-Play.webp",
        type: "Virtual-Baseball-In-Play"
      },
      {
        title: "Virtual-Basketball-League",
        img: "Virtual-Basketball-League.webp",
        type: "Plinko"
      }
    ];

    if (props.data === 'All') {
      setGames(casinoArray.filter(a => a.type !== '7mojos'));
    } else if(['Baccarat', 'Roulette'].includes(props.data)) {
      const filData = casinoArray.filter(f => f.type === props.data);
      setGames(filData);
    } else if (props.data === '7mojos') {
      const mojosFil = casinoArray.filter(f => f.type === props.data);
      setGames(mojosFil);
    }else{
      setGames(casinoArray)
    }

    if(props.is_carousal){
      setCarousal(true)
    }

    const getPlayerInfo = JSON.parse(localStorage.getItem("loginUserInfo"));

  }, [props.data]);

  return (
    <>
    {
      !props.origin 
      ?
        <Container fluid >
          <Row className="mt-2">
            
            {games.map((data, idx) => (
              <Col key={idx} xs={6} sm={6} md={props.layout} className={`pr-1 pt-2 pl-1 cursor ${props.origin ? props.origin : ''}`}>
                <img
                  alt={data.title}
                  title={data.title}
                  onClick={() => showEvolution(data.title)}
                  src={`${MEDIA_URL}/casino-gif/`+ data.img}
                />
              </Col>
            ))}
          </Row>
        </Container>
      :
        <Row className="m-0">
          {
              Carousal == true
              ?
                <>
                <OwlCarousel className='portal-casino owl-theme' loop margin={10}  items={3.5} autoplay={true} dots={false}>
                  {
                    games.map((data, idx) => (
                      <div key={idx}>
                        <img
                          alt={data.title}
                          title={data.title}
                          onClick={() => showEvolution(data.title)}
                          src={`${MEDIA_URL}/casino-gif/`+ data.img}
                        />
                      </div>
                    ))
                  }
                  </OwlCarousel>
                </>
              : 
                
                games.map((data, idx) => (
                  <Col key={idx} xs={6} sm={6} md={props.layout} className={`cursor ${props.origin ? props.origin : ''}`}>
                    <img
                      alt={data.title}
                      title={data.title}
                      onClick={() => showEvolution(data.title)}
                      src={`${MEDIA_URL}/casino-gif/`+ data.img}
                    />
                  </Col>
                ))
            }
            </Row>
    }
    
    </>
  );
};

export default withRouter(VirtualGames);
